import axios from "axios";

// The Windows EXE injects window.__TRMD_API_BASE (production login/HWID host) before the app loads.
const BACKEND_URL = (typeof window !== "undefined" && window.__TRMD_API_BASE) || process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// TRMD Android app signs every API request (Windows app signs in its native shell).
api.interceptors.request.use((cfg) => {
  try {
    const n = window.TiroNative;
    if (n && typeof n.trmdHeaders === "function") Object.assign(cfg.headers, JSON.parse(n.trmdHeaders()));
  } catch (_) { /* not in the Android app */ }
  return cfg;
});
